import * as React from 'react'
import * as PropTypes from 'prop-types'

const keyTypes: { [key: string]: (e: KeyboardEvent) => boolean } = {
  escape: e => e.key === 'Escape' || e.which === 27,
}

interface ICatchGlobalKeyProps {
  onKey?: () => void
  keyType: 'escape'
  children: React.ReactNode
}

export default class CatchGlobalKey extends React.Component<ICatchGlobalKeyProps> {
  static propTypes = {
    onKey: PropTypes.func,
    keyType: PropTypes.oneOf(Object.keys(keyTypes)).isRequired,
    children: PropTypes.node,
  }

  componentDidMount() {
    window.requestAnimationFrame(() => window.addEventListener('keyup', this.handleGlobalKeyUp))
  }

  componentWillUnmount() {
    window.removeEventListener('keyup', this.handleGlobalKeyUp)
  }

  handleGlobalKeyUp = (e: KeyboardEvent) => {
    if (keyTypes[this.props.keyType](e)) {
      e.stopPropagation()
      e.preventDefault()
      this.props.onKey && this.props.onKey()
    }
  }

  render() {
    return this.props.children
  }
}
